import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';
import type { Context } from 'aws-lambda';

let _globalContext: Context | undefined = undefined;
export const getGlobalContext = () => _globalContext;
export function setGlobalContext(context: Context): void {
  _globalContext = context;
}

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
